
export const GlobalData = {
  // Llama a todas las APIS que traen los datos necesarios para el funcionamiento del sitio
  async init() {
    await this.getMenuUnificado()
  },

  async getMenuUnificado() {
    const token: string = localStorage.getItem('token')
    const url  = `${process.env.API}/api/Menu/menu-unificado`
    const response = await fetch(url, {
      method: 'GET',
      headers:{
        'authorization': token
      }
    })
    const json = await response.json()
    const datos = json.respuesta
    console.log('datos menu unificado', datos)
    localStorage.setItem(
      'menu',
      JSON.stringify(datos.menuPrincipal.result.datos)
    )
    localStorage.setItem(
      'menuempresa',
      JSON.stringify(datos.menuEmpresa.result.datos)
    )
    localStorage.setItem(
      'menuusuario',
      JSON.stringify(datos.menuUsuario.result.datos)
    )
    localStorage.setItem(
      'messages',
      JSON.stringify(datos.mensajes.result.datos)
    )
  }
}
